import script from "./InvoiceDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceDetailView.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceDetailView.vue?vue&type=style&index=0&id=55a8ad1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55a8ad1d"]])

export default __exports__